import { useTranslation } from "react-i18next"
import { PageChrome } from "@/components/page-chrome"
import { Home } from "lucide-react"
import { Card, CardContent } from "@/components/ui/card"
import { WorkspaceLinkCards } from "@/components/workspace/link-cards"
import { PageBody } from "@/components/ui/layout"
import { WORKSPACE_OWNERS } from "@/components/workspace/definition"
import { useRouteWorkspace } from "@/components/workspace/page-chrome"
import { LearnersWorkspacesStudent } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

type ShowProps = {
  student: LearnersWorkspacesStudent
}

const useShowProps = () => useProps<ShowProps>()

export default function Page() {
  const { t } = useTranslation("nav")
  const { student } = useShowProps()
  const workspace = useRouteWorkspace(WORKSPACE_OWNERS.student)

  return (
    <>
      <PageChrome
        icon={Home}
        title={t("student_workspace_title", { name: student.full_name })}
      />
      <PageBody>
        <Card>
          <CardContent
            className="grid grid-cols-2 gap-6 py-6"
            aria-label="Actions"
            role="navigation"
          >
            <WorkspaceLinkCards workspace={workspace} />
          </CardContent>
        </Card>
      </PageBody>
    </>
  )
}
